// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1745": "f142f836ba45","2162": "50116afa419c","3503": "d6f7ebb783ca","6863": "454c9f289029",}[chunkId] + ".css"
}